import type { Dictionary, ParsedProperty } from '@witmetrics/utils';
import { API } from '@/api';
import type { NewLeadData } from './types';

export const classes = {
  wrapper: 'flex py-6',
  column: 'flex flex-col gap-4 w-1/2 grow',
  divider: 'mx-8',
  instructions: 'text-sm text-grey-7 dark:text-mauve-2 mb-4 mt-[-1rem]',
  list: 'mt-4 h-[40vh] overflow-auto',
  listItem:
    'bg-grey-2 dark:bg-white/[0.06] hover:bg-grey-3 dark:hover:bg-white/[0.1] rounded-2xl cursor-pointer text-sm text-grey-8 dark:text-mauve-1 px-4 py-3 mb-2 transition-colors select-none',
  activeItem: 'bg-orange-1/30 text-orange-3 font-medium',
  form: 'w-full flex flex-col gap-4',
  searchField: 'mt-[-0.75rem]',
  button: 'mt-4',
};

export function createLead(
  practiceId: number,
  practiceProperties: Dictionary<ParsedProperty>,
  data: NewLeadData
) {
  return API.Leads.createNewLead({
    ...data,
    properties: [
      {
        propertyId: practiceProperties.enquiryStatus.id,
        value: 'Treatment accepted',
      },
    ],
    practiceId,
  });
}
